import PropTypes from "prop-types";
import Section from "components/residency/Section";
import Container from "components/residency/Container";
import Title from "components/residency/Title";
import Text from "components/residency/Text";
import styles from "components/residency/Accommodation.module.scss";
import ImageOrCloudfront from "helpers/ImageOrCloudfront";

export default function Accommodation({ title, description, images }) {
  return (
    <Section className={styles.component} id="where">
      <div className={styles.grid}>
        <div className={styles.visual}>
          <div className={styles.imageGrid}>
            <div className={styles.imageGridItem}>
              <ImageOrCloudfront
                image={images[0]}
                className={styles.image}
                altName="Accommodations first photo"
              />
            </div>
            <div className={styles.imageGridRow}>
              <div className={styles.imageGridItem}>
                <ImageOrCloudfront
                  image={images[1]}
                  className={styles.image}
                  altName="Accommodations second photo"
                />
              </div>
              <div className={styles.imageGridItem}>
                <ImageOrCloudfront
                  image={images[2]}
                  className={styles.image}
                  altName="Accommodations third photo"
                />
              </div>
            </div>
          </div>
        </div>
        <Container className={styles.content}>
          <Title size="lg" className={styles.title}>
            {title}
          </Title>
          <Text className={styles.description}>{description}</Text>
        </Container>
      </div>
    </Section>
  );
}

Accommodation.propTypes = {
  title: PropTypes.node.isRequired,
  description: PropTypes.string.isRequired,
  images: PropTypes.arrayOf(
    PropTypes.shape({
      width: PropTypes.number,
      height: PropTypes.number,
    })
  ),
};
